import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import type { ActionsObservable } from 'redux-observable';
import type { Action } from '../../state/actions';
import type { AppState } from '../../state/types';
import { DELETE_PROJECT_SUCCESS } from '../../state/ui/actions';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, _: MiddlewareAPI<AppState>) =>
	action$
		.ofType(DELETE_PROJECT_SUCCESS)
		.do(() => {
			const redirectUrl = '/';
			window.location.replace(redirectUrl);
		})
		.ignoreElements();
